module.exports = __webpack_public_path__ + "static/media/logo.e47de960.png";